import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SigninComponent } from './components/auth/signin/signin.component';
import { UserRole } from './enums/enums';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { AuthGuard } from './services/app/auth-guard/auth.guard';
import { PublicGuard } from './services/app/public-guard/public.guard';
import { ProfileComponent } from './components/profile/profile.component';
import { ResetPasswordComponent } from './components/auth/reset-password/reset-password.component';
import { NotificationsComponent } from './components/shared/layout/notifications/notifications.component';
import { CreateTripComponent } from './components/distributions/trip-intake/create-trip/create-trip.component';
import { TripListComponent } from './components/distributions/trips/trip-list/trip-list.component';
import { StandingOrderListComponent } from './components/distributions/trip-intake/standing-order/standing-order-list/standing-order-list.component';
import { TripMonitoringComponent } from './components/distributions/trips/trip-monitoring/trip-monitoring.component';
import { StandingOrderTripWrapperComponent } from './components/distributions/trip-intake/standing-order-trip-wrapper/standing-order-trip-wrapper.component';
import { AddMemberComponent } from './components/distributions/member/add-member/add-member.component';
import { ForgotPasswordComponent } from './components/auth/forgot-password/forgot-password/forgot-password.component';
import { PaymentsListComponent } from './components/payments/payments-list/payments-list.component';
import { TransactionsListComponent } from './components/payments/transactions-list/transactions-list.component';
import { RegisterComponent } from './components/auth/register/register.component';
import { TutorialsListComponent } from './components/tutorials/tutorials-list/tutorials-list.component';

import { SupportTicketsComponent } from './components/support/support-tickets/support-tickets.component';
import { SupportChatComponent } from './components/support/support-chat/support-chat.component';
import { TicketDetailComponent } from './components/support/ticket-detail/ticket-detail.component';
import { AddSupportTicketComponent } from './components/support/add-support-ticket/add-support-ticket.component';

const routes: Routes = [
  { path: 'login', component: SigninComponent, canActivate: [PublicGuard] },
  { path: 'signup', component: RegisterComponent, canActivate: [PublicGuard] },

  { path: '', redirectTo: '/trips', pathMatch: 'full' },

  // {
  //   path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard], data: {
  //     role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
  //   }
  // },

  // profile
  {
    path: 'profile', component: ProfileComponent, canActivate: [AuthGuard], data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },


  {
    path: 'reset-password',
    component: ResetPasswordComponent,
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
  },
  {
    path: 'notifications',
    component: NotificationsComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },

  // Trips

  {
    path: 'trips',
    component: TripListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/new',
    component: CreateTripComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/:tripId/edit',
    component: CreateTripComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
 
  {
    path: 'trips/standing-order',
    component: StandingOrderListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/standing-order/new',
    component: StandingOrderTripWrapperComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/:standingOrderId/standing-order/edit',
    component: StandingOrderTripWrapperComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  {
    path: 'trips/monitoring',
    component: TripMonitoringComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
  // member
     {
    path: 'member',
    component: AddMemberComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
    {
    path: 'payments',
    component: PaymentsListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER]
    } 
  },
  {
    path: 'payments/transactions',
    component: TransactionsListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER]
    } 
  },
  // support
  {
    path: 'support',
    redirectTo: 'support/tickets',
    pathMatch: 'full'
  },
  {
    path: 'support/tickets',
    component: SupportTicketsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/chats',
    component: SupportChatComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/add',
    component: AddSupportTicketComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'support/tickets/:id',
    component: TicketDetailComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'academy',
    component: TutorialsListComponent,
    canActivate: [AuthGuard],
    data: {
      role: [UserRole.COMPANY, UserRole.ADMIN, UserRole.AUTHORIZER, UserRole.DISPATCHER],
    }
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
